import { ShaderMaterial, Color, Vector3, FrontSide, AdditiveBlending } from 'three'

import shaderFragment from '../shaders/pane/fragment.glsl'
import shaderVertex from '../shaders/pane/vertex.glsl'

export default function (colour = 0x84D45C) {
    const material = new ShaderMaterial({
        uniforms: {
            c: { value: 1.0 },
            p: { value: 1.0 },
            glowColor: { value: new Color(colour) },
            viewVector: { value: new Vector3(1, 1, 1) },
            tBackground: { value: null }
        },
        wireframe: false,
        transparent: false,
        vertexShader: shaderVertex,
        fragmentShader: shaderFragment,
        side: FrontSide,
        blending: AdditiveBlending,
    })

    return material
}
